import type { MatchingRepository } from '../../repositories/ApiMatchingRepository';

export class MatchingService {
  constructor(private readonly repo: MatchingRepository) {}

  getStatus() {
    return this.repo.getStatus();
  }

  setStatus(params: Parameters<MatchingRepository['setStatus']>[0]) {
    return this.repo.setStatus(params);
  }

  getMeta() {
    return this.repo.getMeta();
  }

  preview(params: Parameters<MatchingRepository['preview']>[0]) {
    return this.repo.preview(params);
  }

  create(params: Parameters<MatchingRepository['create']>[0]) {
    return this.repo.create(params);
  }

  update(params: Parameters<MatchingRepository['update']>[0]) {
    return this.repo.update(params);
  }

  cancel(params: Parameters<MatchingRepository['cancel']>[0]) {
    return this.repo.cancel(params);
  }

  copy(params: Parameters<MatchingRepository['copy']>[0]) {
    return this.repo.copy(params);
  }

  restore(params: Parameters<MatchingRepository['restore']>[0]) {
    return this.repo.restore(params);
  }

  getBoard(params: Parameters<MatchingRepository['getBoard']>[0]) {
    return this.repo.getBoard(params);
  }

  getPanel(params: Parameters<MatchingRepository['getPanel']>[0]) {
    return this.repo.getPanel(params);
  }

  getEventViews(params: Parameters<MatchingRepository['getEventViews']>[0]) {
    return this.repo.getEventViews(params);
  }
}
